import React, { useEffect, useRef, useState } from 'react';
import { saveAs } from 'file-saver';
import { Icon, IconButton, Menu, MenuItem } from '@material-ui/core';
import { ConfirmDialog } from '@sierralabs/core-ui';
import { useDeleteFormTemplate, useUpdateFormTemplate } from '../../FormTemplate.hooks';
import { FormTemplateEditDialog } from '../../dialogs/FormTemplateEditDialog';
const FormTemplateMenuButton = ({ form, onUpdate, onDelete }) => {
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [formMenuAnchor, setFormMenuAnchor] = useState(null);
    const { updatedFormTemplate, updateFormTemplate } = useUpdateFormTemplate(form.id);
    const { deletedFormTemplate, deleteFormTemplate } = useDeleteFormTemplate(form.id);
    const onDeleteRef = useRef(onDelete);
    onDeleteRef.current = onDelete;
    const onUpdateRef = useRef(onUpdate);
    onUpdateRef.current = onUpdate;
    useEffect(() => {
        var _a;
        if (deletedFormTemplate) {
            (_a = onDeleteRef.current) === null || _a === void 0 ? void 0 : _a.call(onDeleteRef);
        }
        setFormMenuAnchor(null);
    }, [deletedFormTemplate]);
    useEffect(() => {
        var _a;
        if (updatedFormTemplate) {
            (_a = onUpdateRef.current) === null || _a === void 0 ? void 0 : _a.call(onUpdateRef);
        }
        setFormMenuAnchor(null);
    }, [updatedFormTemplate]);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { size: 'small', onClick: event => {
                event.preventDefault();
                setFormMenuAnchor(event.currentTarget);
            } },
            React.createElement(Icon, { className: 'more-icon' }, "more_vert")),
        React.createElement(Menu, { id: 'form-more-menu', anchorEl: formMenuAnchor, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, open: Boolean(formMenuAnchor), onClose: () => {
                setFormMenuAnchor(null);
            } },
            React.createElement(MenuItem, { onClick: () => setOpenEditDialog(true) }, "Edit Form"),
            React.createElement(MenuItem, { onClick: () => {
                    setFormMenuAnchor(null);
                    const exportForm = Object.assign({}, form);
                    delete exportForm.isDeleted;
                    const blob = new Blob([JSON.stringify(exportForm, undefined, 2)], {
                        type: 'application/json'
                    });
                    saveAs(blob, `${form.name} Form.json`);
                } }, "Export Form"),
            React.createElement(MenuItem, { onClick: () => {
                    (form === null || form === void 0 ? void 0 : form.isDeleted)
                        ? updateFormTemplate({ isDeleted: false })
                        : setOpenConfirmDialog(true);
                } }, form.isDeleted ? 'Undelete Form' : 'Delete Form')),
        React.createElement(FormTemplateEditDialog, { open: openEditDialog, formTemplate: form, onCancel: () => setOpenEditDialog(false), onUpdate: () => {
                var _a;
                (_a = onUpdateRef.current) === null || _a === void 0 ? void 0 : _a.call(onUpdateRef);
                setFormMenuAnchor(null);
                setOpenEditDialog(false);
            } }),
        React.createElement(ConfirmDialog, { open: openConfirmDialog, title: 'Delete Form Template', message: `Are you sure you want to delete the "${form.name}" template? `, confirmLabel: 'Delete', onCancel: () => setOpenConfirmDialog(false), onConfirm: () => {
                setOpenConfirmDialog(false);
                deleteFormTemplate();
            } })));
};
export default FormTemplateMenuButton;
//# sourceMappingURL=FormTemplateMenuButton.js.map